
      var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 21,
  width: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 2,
  width: 20,
  height: 20,
  rx: 10,
  fill: "var(--theme-bright, #e3d2e9)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrowdown_6bc2d962e27702c1__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 10.5 12 14.25 8.25 10.5",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrowdown_6bc2d962e27702c1__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  transform: "translate(6 6)",
  d: "M0 0h12v12H0z"
})))));

      const __svgRaw = "<svg height=\"21\" width=\"20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">     <rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"10\" fill=\"var(--theme-bright, #e3d2e9)\"></rect>     <g clip-path=\"url(#b3fliw5h1a)\">         <path d=\"M15.75 10.5 12 14.25 8.25 10.5\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>     </g>     <defs>         <clipPath id=\"b3fliw5h1a\">             <path fill=\"var(--theme-light, #f9f3fb)\" transform=\"translate(6 6)\" d=\"M0 0h12v12H0z\"></path>         </clipPath>     </defs>    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrowdown.6bc2d962e27702c1349f715e98e41d96.svg"),
        {
          React: SvgArrowdown,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      